module.exports = __webpack_public_path__ + "static/media/instagram-dark.3ed92705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/instagram-dark.svg
// module id = 434
// module chunks = 0